import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Observable, Subject, Subscription, pipe, throwError } from 'rxjs';
import { EditState, LayoutState, VisualEditorState } from '../model';
import { catchError, concatMap, filter, map, switchMap, tap } from 'rxjs/operators';
import { LayoutEditorService } from '../editors/layout-editor/layout-editor.service';
import { ContentStatusEnum, Page, PageType, Section, Site, SiteEditorConfig, SiteHeader } from '../editor-container/editor-model';
import { SiteConfigListenerService } from './site-config-listener.service';
import { takeUntil } from 'rxjs/operators';
import { GridCell, HeaderConfig, RowCell, ThemeConfig } from '@urbannex/storethemes';
import { IframeCommunicationService } from './iframe-communication.service';


export const initialState: VisualEditorState = {
  layoutState: undefined,
  siteEditorSitesState: undefined,
  selectedSite: undefined,
  headerState: undefined,
  selectedPage: null,
  selectedPageType: null,
  selectedSection: null,
  selectedCell: {},
  editState: EditState.LOADING,
  sectionEditState: null,
  pageEditState: null,
  hasUnsavedChanges: false,
}
@Injectable({
  providedIn: 'root'
})
export class PreviewEditStoreService extends ComponentStore<VisualEditorState> {
  // destroy$: Subject<void> = new Subject<void>();
  // layoutSubscription:Subscription = this.layout
  /* layoutScreenSubscription:Subscription = this.layoutEditorService.getScreenWidth().subscribe(screenWidth => {
    this.layoutState$.pipe(map(_pallette => _pallette.pallette),
    catchError(err => {
      console.log('Handling error locally and rethrowing it...', err);
      return throwError(err);
  }),
  ).subscribe(_layoutState => {
      if(_layoutState != undefined && screenWidth != undefined){
        let layoutState:LayoutState = {screenWidth:screenWidth,pallette:_layoutState.pallette};
        this.updateLayoutState(layoutState);
      }
    })
  })
  layoutPalletteSubscription:Subscription = this.layoutEditorService.getPallette().subscribe(pallette => {
    this.layoutState$.subscribe(_layoutState => {
      if(_layoutState != undefined && pallette != undefined){
        let layoutState:LayoutState = {screenWidth:_layoutState.screenWidth,pallette:pallette};
        this.updateLayoutState(layoutState);
      }
    })
  }) */

  siteConfigSub: Subscription;
  selectedPageSub: Subscription;

  constructor(
    private siteConfigListenerService: SiteConfigListenerService,
    private layoutEditorService: LayoutEditorService,
    private communicator: IframeCommunicationService) {
    super(initialState);
    this.siteConfigListenerService.isLoaded
      .pipe(takeUntil(this.destroy$))
      .subscribe(isLoaded => {
        if (isLoaded == true) {
          console.log("Locked and loaded")
          this.updateEditState(EditState.EDITING);
        }
      })

    /* this.siteConfigListenerService.initSiteEditorConfig()
        .pipe(takeUntil(this.destroy$))
        .subscribe((siteEditorSites) => {
          if(siteEditorSites != null){
            if(siteEditorSites.sites.length > 0){
              this.updateEditState(EditState.EDITING);
              console.log(siteEditorSites);
              //this.updateSiteEditorConfigState(siteEditorSites)
              this.updateSelectedSite(siteEditorSites.sites[0])
            }
          }
        }) */
    siteConfigListenerService.getSelectedPageType().pipe(takeUntil(this.destroy$))
      .subscribe(pageType => {
        console.log("Track selected Page: " + pageType)
        this.setSelectedPage(pageType);
      })


  }

  init() {
    console.log("Loading shit");
    console.log("Initing things");
    const sites: Site[] = [];
    // const site: Site;
    this.loadConfig();
    /* this.siteConfigSub = this.siteConfigListenerService.initSiteEditorConfig().pipe(
      takeUntil(this.destroy$),
      tap((siteEditorSites:Site[]) => {
        console.log(siteEditorSites)
        console.log(siteEditorSites[0]);
        this.updateSiteEditorConfigState(siteEditorSites);
      }),
      map((siteEditorSites:Site[]) => {
        console.log(siteEditorSites[0]);
        this.setSelectedSite(site);
        return siteEditorSites[0]
      }),
      map((site:Site) => {
        console.log(site);
        this.siteConfigListenerService.getSelectedPageType().pipe(takeUntil(this.destroy$))
        .subscribe(pageType => {
          console.log("Track selected Page: "+pageType)
          this.setSelectedPage(pageType);
        })
        return site
      })).subscribe((site:Site) => {
        if(site != undefined){
          this.updateEditState(EditState.EDITING);
          console.log(site)
        }
      }); */

  }


  loadConfig = this.effect<void>(
    trigger$ => trigger$.
      pipe(
        map(() => {
          console.log("tapping")
          this.siteConfigListenerService.initSiteEditorConfig()
            .pipe(takeUntil(this.destroy$))
            .subscribe((siteEditorSites) => {
              if (siteEditorSites != null) {
                console.log(siteEditorSites)
                if (siteEditorSites.length > 0) {
                  console.log(siteEditorSites[0])
                  this.updateSiteEditorConfigState(siteEditorSites)
                  this.updateSelectedSite(siteEditorSites[0])
                  this.updateEditState(EditState.EDITING);
                }
              }
            })
        })
      )
  )

  testUpdate() {
    this.siteEditorSitesState$.subscribe(data => {
      console.log(data)
    })
  }

  /* readonly testSelectedCell = this.effect((selectedCell$:Observable<GridCell | RowCell>)=> {
    return selectedCell$.pipe(
      tap((selectedCell:string) => {
        this.selectedSection$.subscribe(data => console.log(data));
        console.log(selectedCell)
        return this.selectedCell$
      })
      )

  }) */
  /* loadConfig = this.effect((trigger$) => {
    return trigger$.pipe(
      map(() => {
        console.log("tapping")
        this.siteConfigListenerService.initSiteEditorConfig()
          .subscribe((siteEditorSites) => {
            console.log(siteEditorSites)
            this.updateSiteEditorConfigState(siteEditorSites)
            this.siteEditorSitesState$.subscribe(data => {
              console.log(data)
            })
          })
      })
    )
  }) */


  /* readonly pallette = this.lookUpQuerySubject.pipe(
    liveSearch(query => this.lookUpService.doLookUp(this.baseUrl,query,this.lookUpEndPoint))
  ) */

  // Updaters
  readonly updateState = this.updater((state: VisualEditorState, updatedState: VisualEditorState) => state);
  readonly updateLayoutState = this.updater((state: VisualEditorState, layoutState: LayoutState) => {
    console.log("updating layout");
    return {
      ...state,
      layoutState: layoutState
    }
  })

  readonly updateSiteEditorConfigState = this.updater((state: VisualEditorState, siteEditorSites: Site[]) => {
    console.log("updating config");
    // console.log(siteEditorSites);
    return {
      ...state,
      siteEditorSitesState: siteEditorSites
    }
  })

  readonly updatePageType = this.updater((state: VisualEditorState, selectedPageType: PageType) => {
    return {
      ...state,
      selectedPageType: selectedPageType
    }
  })

  readonly updateSelectedSite = this.updater((state: VisualEditorState, selectedSite: Site) => {
    console.log("Setting selected site", selectedSite)
    return {
      ...state,
      selectedSite: selectedSite
    }
  })

  readonly updateSiteHeader = this.updater((state: VisualEditorState, siteHeader: HeaderConfig) => {
    return {
      ...state,
      headerState: siteHeader
    }
  })

  readonly updateSelectedPage = this.updater((state: VisualEditorState, selectedPage: Page) => {
    console.log("Updated page selection", selectedPage);
    return {
      ...state,
      selectedPage: selectedPage
    }
  })
  /**
   * Updates the selected section in the state.
   * Use when the user is actively editing the currently selected section (e.g., user changes section properties in a form)
   */
  readonly updateSelectedSection = this.updater((state: VisualEditorState, selectedSection: Section) => {
    console.log("Updated section selection", selectedSection);

    if (!state.selectedPage) {
      return {
        ...state,
        selectedSection: { ...selectedSection }
      };
    }

    // Find and update the section in the page's sections array
    const updatedSections = state.selectedPage.sections.map(s =>
      s.sectionId === selectedSection.sectionId ? { ...selectedSection } : s
    );

    // Create updated page with the modified section
    const updatedPage = new Page({
      ...state.selectedPage,
      sections: updatedSections,
      hasUnsavedChanges: true
    });

    return {
      ...state,
      selectedPage: updatedPage,
      selectedSection: { ...selectedSection },
      hasUnsavedChanges: true
    };
  });
  /**
   * Updates the selected section in the state.
   * Use when the user is actively editing the currently selected section (e.g., user changes section properties in a form)
   */
  readonly old_UpdateSelectedSection = this.updater((state: VisualEditorState, selectedSection: Section) => {
    console.log("Updated section selection", selectedSection);
    return {
      ...state,
      selectedSection: { ...selectedSection }
    }
  })

  readonly updateSelectedCell = this.updater((state: VisualEditorState, selectedCell: GridCell | RowCell) => {
    console.log("Updated cell selection", selectedCell);
    return {
      ...state,
      selectedCell: selectedCell
    }
  })

  readonly updateEditState = this.updater((state: VisualEditorState, editingState: EditState) => {
    return {
      ...state,
      editState: editingState
    }
  })

  readonly updateSectionEditState = this.updater((state: VisualEditorState, sectionEditState: EditState) => {
    return {
      ...state,
      editState: sectionEditState
    }
  })

  readonly updatePageEditState = this.updater((state: VisualEditorState, pageEditState: EditState) => {
    console.log(pageEditState)
    return {
      ...state,
      pageEditState: pageEditState
    }
  });
  /**
   * Updates a section within the selected page and marks the page as having unsaved changes.
   * Use when you just need to update a section's data without changing the selection (e.g., auto-save, batch updates)
   */
  readonly updateSection = this.updater((state, section: Section) => {
    if (!state.selectedPage) return state;

    const updatedSections = state.selectedPage.sections.map(s =>
      s.sectionId === section.sectionId ? section : s
    );

    const updatedPage = new Page({
      ...state.selectedPage,
      sections: updatedSections,
      hasUnsavedChanges: true
    });

    return {
      ...state,
      selectedPage: updatedPage,
      hasUnsavedChanges: true
    };
  });
  /**
   * Adds a new section to the selected page and marks the page as having unsaved changes.
   */
  readonly addSection = this.updater((state, section: Section) => {
    if (!state.selectedPage) return state;

    const updatedSections = [...state.selectedPage.sections, section];

    const updatedPage = new Page({
      ...state.selectedPage,
      sections: updatedSections,
      hasUnsavedChanges: true
    });

    return {
      ...state,
      selectedPage: updatedPage,
      selectedSection: section,
      hasUnsavedChanges: true
    };
  });
  /**
   * Removes a section from the selected page by its ID and marks the page as having unsaved changes.
   */
  readonly removeSection = this.updater((state, sectionId: string) => {
    if (!state.selectedPage) return state;

    const updatedSections = state.selectedPage.sections.filter(
      s => s.sectionId !== sectionId
    );

    const updatedPage = new Page({
      ...state.selectedPage,
      sections: updatedSections,
      hasUnsavedChanges: true
    });

    return {
      ...state,
      selectedPage: updatedPage,
      selectedSection: null,
      hasUnsavedChanges: true
    };
  });
  /**
   * Updates the status of the selected page and marks it as having unsaved changes.
   */
  readonly updatePageStatus = this.updater((state, status: ContentStatusEnum) => {
    if (!state.selectedPage) return state;

    const updatedPage = new Page({
      ...state.selectedPage,
      status: status,
      hasUnsavedChanges: true
    });

    return {
      ...state,
      selectedPage: updatedPage,
      hasUnsavedChanges: true
    };
  });
  /**
   * Marks the selected page as saved, updating its persisted status and resetting the unsaved changes flag.
   */
  readonly markPageAsSaved = this.updater((state) => {
    if (!state.selectedPage) return state;

    state.selectedPage.markAsSaved();

    return {
      ...state,
      selectedPage: state.selectedPage,
      hasUnsavedChanges: false
    };
  });
  /**
   * Resets the unsaved changes flag without modifying the selected page.
   */
  readonly resetUnsavedChanges = this.updater((state) => ({
    ...state,
    hasUnsavedChanges: false
  }));



  // Selectors
  readonly layoutState$: Observable<LayoutState> = this.select(state => state.layoutState);
  readonly siteEditorSitesState$: Observable<Site[]> = this.select(state => state.siteEditorSitesState);
  readonly selectedSite$: Observable<Site> = this.select(state => state.selectedSite);
  readonly siteHeader$: Observable<HeaderConfig> = this.select(state => state.headerState);
  readonly selectedPage$: Observable<Page> = this.select(state => state.selectedPage);
  readonly selectedSection$: Observable<Section> = this.select(state => state.selectedSection);
  readonly selectedPageType$: Observable<PageType> = this.select(state => state.selectedPageType);
  readonly selectedCell$: Observable<GridCell | RowCell> = this.select(state => { console.log("Selected Cell Called", state.selectedCell); return state.selectedCell });
  readonly editState$: Observable<EditState> = this.select(state => state.editState);
  readonly sectionEditState$: Observable<EditState> = this.select(state => state.sectionEditState);
  readonly pageEditState$: Observable<EditState> = this.select(state => state.pageEditState);
  readonly hasUnsavedChanges$: Observable<boolean> = this.select(
    state => state.selectedPage?.hasUnsavedChanges ?? false
  );

  readonly canSavePage$: Observable<boolean> = this.select(
    state => {
      const page = state.selectedPage;
      if (!page) return false;
      // Can save if there are unsaved changes
      return page.hasUnsavedChanges === true;
    }
  );

  // ViewModel for the component
  readonly editModel$ = this.select(
    this.editState$,
    this.selectedSite$,
    this.selectedPage$,
    (editState, selectedSite, selectedPage) => ({
      editState,
      selectedSite,
      selectedPage
    })
  );
  // Effects
  // Effects
  readonly setSelectedCell = this.effect((selectedCell$: Observable<GridCell | RowCell>) => {
    console.log("Setting selected cell", selectedCell$);
    return selectedCell$.pipe(
      tap((selectedCell: GridCell | RowCell) => {
        // this.selectedSection$.subscribe(data => console.log(data));
        // console.log(selectedCell);
        this.updateSelectedCell(selectedCell);
        // this.selectedCell$.subscribe(data => console.log(data));
        // return this.selectedCell$
      })
    )

  })

  readonly setSelectedSite = this.effect((site$: Observable<Site>) => {
    return site$.pipe(
      tap((site: Site) => {
        console.log(site)
        if (site != undefined) {
          site.siteHeader
          this.updateSelectedSite(site);
          if (site.pages != undefined && site.pages != null) {
            this.updateSelectedPage(site.pages[0]);
          }
          if (site.siteHeader != null && site.siteHeader != undefined) {
            this.updateSiteHeader(site.siteHeader);
          }
        }
      })
    )
  })

  readonly setSameLayout = this.effect((layoutClass$: Observable<string>) => {
    return layoutClass$.pipe(
      tap((layoutClass: string) => {
        console.log("Same layout")
        this.selectedSection$.subscribe((section: Section) => {
          console.log(section.rendererType);
          switch (section.rendererType) {
            case "testimonials":
              const testimonialsCells: GridCell[] = section.sectionData.testimonialOptions.rowCells;
              if (testimonialsCells != undefined) {
                testimonialsCells.forEach(cell => {
                  cell.layoutClass = layoutClass;
                  this.updateSelectedCell(cell);
                })
              }
              break;
            case "banner":

              break;
            case "grid":
              const gridCells: GridCell[] = section.sectionData.gridOptions.gridCells;
              if (gridCells != undefined) {
                gridCells.forEach(gridCell => {
                  gridCell.layoutClass = layoutClass;
                  this.updateSelectedCell(gridCell);
                })
              }
              break;

            default:
              break;
          }


        })
      })
    )
  })

  readonly setRowCellsSame = this.effect((selectedCell$: Observable<GridCell | RowCell>) => {
    return selectedCell$.pipe(
      tap((selectedCell: GridCell | RowCell) => {
        const layoutClass = selectedCell.layoutClass;
        const fillClass = selectedCell.fillClass;
        const fillColor = selectedCell.fillColor;
        this.selectedSection$.subscribe((section: Section) => {
          switch (section.rendererType) {
            case "testimonials":
              const testimonialsCells: GridCell[] | RowCell[] = section.sectionData.testimonialOptions.rowCells;
              testimonialsCells.forEach((cell: GridCell | RowCell) => {
                if (cell.cellId != selectedCell.cellId) {
                  cell.layoutClass = layoutClass;
                  cell.fillClass = fillClass;
                  cell.fillColor = fillColor;
                  selectedCell.contentElements.forEach(cntEl => {
                    const cpyEl = cell.contentElements.find(el => el.name === cntEl.name);
                    if (cpyEl) {
                      cpyEl.containerClasses = cntEl.containerClasses;
                      cpyEl.classes = cntEl.classes;
                      if (cntEl.background) { cpyEl.background = cntEl.background; }
                      if (cntEl.color) { cpyEl.color = cntEl.color }
                      if (cntEl.borderColor) { cpyEl.borderColor = cntEl.borderColor };
                      if (cntEl.fontFamily) { cpyEl.fontFamily = cntEl.fontFamily }
                      if (cntEl.parentBackground) { cpyEl.parentBackground = cntEl.parentBackground }
                    }
                  })
                  this.updateSelectedCell(cell);
                }
              })
              break;
            case "row":
              const rowCells = section.sectionData.rowCells;
              break;
            case "bloglist":
              break;
          }
        })
      })
    )
  })

  readonly setSameTheme = this.effect((baseCell$: Observable<GridCell | RowCell>) => {
    return baseCell$.pipe(
      tap((baseCell: GridCell | RowCell) => {
        console.log("Same Theme")
        this.selectedSection$.subscribe((section: Section) => {
          switch (section.rendererType) {
            case "testimonials":
              const testimonialsCells: GridCell[] = section.sectionData.testimonialOptions.rowCells;
              if (testimonialsCells != undefined) {
                testimonialsCells.forEach(cell => {
                  if (cell.cellId != baseCell.cellId) {
                    baseCell.contentElements.forEach(cntEl => {
                      const cpyEl = cell.contentElements.find(el => el.name === cntEl.name);
                      if (cpyEl) {
                        cpyEl.containerClasses = cntEl.containerClasses;
                        cpyEl.classes = cntEl.classes;
                        if (cntEl.background) { cpyEl.background = cntEl.background; }
                        if (cntEl.color) { cpyEl.color = cntEl.color }
                        if (cntEl.borderColor) { cpyEl.borderColor = cntEl.borderColor };
                        if (cntEl.fontFamily) { cpyEl.fontFamily = cntEl.fontFamily }
                        if (cntEl.parentBackground) { cpyEl.parentBackground = cntEl.parentBackground }
                      }
                    })
                    cell.fillColor = baseCell.fillColor;
                    cell.fillClass = baseCell.fillClass;
                    cell.bgColor = baseCell.bgColor;
                    this.updateSelectedCell(cell);
                  }

                })
              }
              break;
            case "banner":

              break;
            case "grid":
              const gridCells: GridCell[] = section.sectionData.gridOptions.gridCells;
              if (gridCells != undefined) {
                gridCells.forEach(gridCell => {
                  // gridCell.themeClass = themeClass;
                  this.updateSelectedCell(gridCell);
                })
              }
              break;

            default:
              break;
          }


        })
      })
    )
  })

  readonly setThemeConfig = this.effect((themeConfig$: Observable<ThemeConfig>) => {
    return themeConfig$.pipe(
      tap((themeConfig: ThemeConfig) => {
        this.selectedSite$.subscribe((site: Site) => {
          site.theme = themeConfig;
          this.updateSelectedSite(site);
        })
      })
    )
  })

  readonly setSelectedPage = this.effect((pageType$: Observable<PageType>) => {
    return pageType$.pipe(
      tap((pageType: PageType) => {
        this.updatePageType(pageType);
        console.log(pageType);
        this.selectedSite$.subscribe((site: Site) => {
          console.log("Selected Site", site);
          if (site != undefined) {
            if (site.pages != undefined && site.pages.length > 0) {
              site.pages.forEach((page: Page) => {
                if (page.pageType == pageType) {
                  console.log("Found page to be updated", page);
                  this.updateSelectedPage(page);
                }
              })
            }
          }/* else{
            this.siteEditorSitesState$.subscribe(config => {
              if(config.sites != undefined){
                this.setSelectedSite(config.sites[0]);
              }
            })
          } */
        })
      })
    )
  })
}

/* return cellId$.pipe(
  concatMap((cellId:string) => {
    console.log(cellId)
    return this.selectedCell$
  })
  ) */
